import React from "react";
import { Helmet } from "react-helmet";
import { FaDotCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import { educareLogo } from "../../assets";
import TopBanner from "../../components/designTab/TopBanner";
import { featuringModules } from "../../constants";

const AboutUs = () => {
  return (
    <div className="w-full h-auto">
      <Helmet>
        <title>About Us - EduCare English Learning Academy</title>
      </Helmet>
      <TopBanner titleText="About Us" />
      <div className="max-w-screen-2xl h-auto mx-auto pt-4 pb-20">
        <div className="w-full shadow-md shadow-primeColor hover:shadow-darkPink transition-hover duration-300 mx-auto h-full flex flex-col justify-top py-14 px-10 lg:px-32 items-start gap-4">
          <div className="w-full flex flex-col gap-4 lg:flex-row justify-between items-center">
            <h1 className="font-titleFont text-2xl md:text-3xl xl:text-4xl font-semibold lg:mb-4 underline underline-offset-8 decoration-[2px] decoration-gray-400">
              Educare English Learning Academy
            </h1>
            <img className="w-52" src={educareLogo} alt="educareLogo" />
          </div>
          <div className="grid grid-cols-1 gap-3 font-bodyFont text-lg text-gray-600 tracking-wide">
            <p>
              Welcome to EduCare English Learning Academy, the premier
              institution for{" "}
              <span className="font-semibold text-primeColor">
                English language learning in Bangladesh
              </span>
              . Our mission is to provide exceptional education in English as a
              second language, fostering academic and personal growth in our
              students. We achieve this through a combination of theoretical and
              practical education, utilizing case studies that mirror real-world
              situations, and through corporate partnerships that help prepare
              our students for the workplace.
            </p>
            <p>
              Our programs are practice-oriented, providing students with work
              experience that enables them to develop critical problem-solving,
              communication, and presentation skills. Our goal is to produce
              future leaders who possess a thirst for knowledge, a drive for
              proficiency, and an eagerness to cultivate strong human bonds.
            </p>
            <div className="flex flex-col">
              <p className="underline underline-offset-4 decoration-gray-400">
                We offer a range of programs to cater to different needs and
                interests, including:
              </p>
              {featuringModules.map((module) => (
                <ul key={module.id}>
                  <Link to={module.link}>
                    <li className="flex flex-row item-start gap-3 mb-[1px] mt-1 ml-10">
                      <FaDotCircle className="text-primeColor mt-1" />
                      <span className="hover:text-primeColor text-primeColor font-medium transition-hover duration-300 cursor-pointer hover:underline decoration-[1px] hover:underline-offset-2">
                        {module.title}:{" "}
                        <span className="text-base font-normal text-gray-600">
                          {module.des}
                        </span>
                      </span>
                    </li>
                  </Link>
                </ul>
              ))}
              <div className="mt-3 text-base flex flex-col gap-2">
                <p>Preparation courses for SSC and HSC exams.</p>
                <p>
                  Phonetics courses and English pronunciation courses for
                  non-native speakers.
                </p>
                <p>
                  In addition to our regular programs, we also work with
                  schools, colleges, and universities to improve their students'
                  English language and presentation skills. Some of the
                  institutions we have collaborated with include BGIFT Institute
                  Of Science & Technology, Gazipur Commerce College, Royan
                  Nursing Institute, Royan Institute, Gazipur Metropolitan, and
                  Agrani Model College.
                </p>
                <p>
                  We have conducted numerous workshops in overseas companies and
                  garment factories, helping employees improve their English
                  communication skills and prepare for interviews and
                  presentations.
                </p>
                <p>
                  At EduCare English Learning Academy, we are committed to
                  providing a comprehensive and dynamic learning experience for
                  all of our students. Begin your journey towards achieving your
                  English language goals today by joining us.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
